import React, { useEffect } from 'react'

export default function ListaDocumentos({ tratamento, categorias = [], download }) {
  useEffect(() => {}, [])

  const categoriaNome = (categoriaId) => {
    const c = categorias.find((categoria) => categoria.id == categoriaId)
    return c ? c.nome : '—'
  }

  return (
    <div>
      <div className='d-none d-md-block'>
        <div
          className='table-responsive plano-tratamento-detalhe-scroll'
          style={{ WebkitOverflowScrolling: 'touch' }}
        >
          <table className='table table-bordered mb-0' style={{ minWidth: '720px' }}>
            <thead>
              <tr>
                <th>Identificador</th>
                <th>Nome do Documento</th>
                <th>Nome do Sistema</th>
                <th>Categoria</th>
              </tr>
            </thead>
            <tbody>
              {(tratamento.documentos || []).map((documento) => (
                <tr key={documento.id} className='cursor-pointer' onClick={() => download(documento)}>
                  <td>{documento.id}</td>
                  <td>{documento.nome}</td>
                  <td>{documento.nomeGerado}</td>
                  <td>{categoriaNome(documento.categoriaId)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className='d-md-none'>
        {(tratamento.documentos || []).map((documento) => (
          <div
            key={documento.id}
            className='card mb-3 shadow-sm border plano-tratamento-card-mobile cursor-pointer'
            onClick={() => download(documento)}
            role='button'
          >
            <div className='card-body p-3 small'>
              <div className='d-flex justify-content-between py-1 border-bottom'>
                <span className='text-muted'>Identificador</span>
                <span className='text-dark'>{documento.id}</span>
              </div>
              <div className='d-flex justify-content-between py-1 border-bottom'>
                <span className='text-muted'>Nome</span>
                <span className='text-dark text-right'>{documento.nome}</span>
              </div>
              <div className='d-flex justify-content-between py-1 border-bottom'>
                <span className='text-muted'>Sistema</span>
                <span className='text-dark text-right small'>{documento.nomeGerado}</span>
              </div>
              <div className='pt-2'>
                <span className='text-muted d-block mb-1'>Categoria</span>
                <span className='text-dark'>{categoriaNome(documento.categoriaId)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
